import { render } from "./IndustrialSafety.vue?vue&type=template&id=b8797116&scoped=true"
import script from "./IndustrialSafety.vue?vue&type=script&lang=js"
export * from "./IndustrialSafety.vue?vue&type=script&lang=js"

import "./IndustrialSafety.vue?vue&type=style&index=0&id=b8797116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8797116"]])

export default __exports__